import cn from "classnames"

import { Flex } from "@/atoms"

import styles from "./CardTemplate.module.scss"

import type { CardTemplateProps } from "./CardTemplate.types"

export const CardTemplate = (props: CardTemplateProps) => (
  <Flex
    className={cn(styles.card, styles.cardBordered, {
      [styles.cardAllow]: props.type === "allow",
      [styles.cardNotAllowed]: props.type === "notAllow",
      [styles.cardWhite]: props.variant === "white"
    })}
  >
    {props.children}
  </Flex>
)
